export const actionTypes = {
  SET_TOURNAMENTDETAILS: "SET_TOURNAMENTDETAILS",
  SET_GAMES: "SET_GAMES",
  PUBLIC_TOURNAMENTS: "PUBLIC_TOURNAMENTS",
  SET_UPDATE_SCORE: "SET_UPDATE_SCORE",
  UPDATE_EC: "UPDATE_EC",
  SET_USER: "SET_USER",
  CLEAR_USER_DATA: "CLEAR_USER_DATA",
};
